module.exports = __webpack_public_path__ + "img/avatar6.a4bbc690.png";